import { BaseModel } from '@/api/base-model'

export class AutoCloseSettings extends BaseModel<AutoCloseSettings> {
    protected collectionName = 'auto_close_settings'

    constructor(
        public id: string,
        public closeEnabled: boolean,
        public closeEnabledAt: Date|null,
        public closeAfterDays: number,
        public notificationEnabled: boolean,
        public perPipelineEnabled: boolean,
        public notificationBeforeDays: number,
    ) { super(id) }

    static fromData(data: any): AutoCloseSettings {
        if (data === null || typeof data === 'string' || data instanceof AutoCloseSettings) {
            return data
        }

        return new AutoCloseSettings(
            data.id,
            data.closeEnabled,
            data.closeEnabledAt,
            data.closeAfterDays,
            data.notificationEnabled,
            data.perPipelineEnabled,
            data.notificationBeforeDays,
        )
    }

    static new(id: string): AutoCloseSettings {
        return new AutoCloseSettings(
            id,
            false,
            null,
            120,
            true,
            false,
            14,
        )
    }
}
